var _path, _rect, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.39 1.11404L30.7041 24.6579C31.0986 25.3555 31.0986 26.1884 30.7041 26.886C30.3096 27.5835 29.6031 28 28.8141 28H2.18586C1.39688 28 0.690355 27.5835 0.295893 26.886C-0.0986309 26.1884 -0.0986309 25.3555 0.295893 24.6579L13.61 1.11404C14.0045 0.41645 14.711 0 15.5 0C16.289 0 16.9955 0.41645 17.39 1.11404ZM28.8142 26.1433C28.9968 26.1433 29.09 26.027 29.1292 25.9576C29.1683 25.8883 29.2205 25.7478 29.1291 25.5863L15.8149 2.04238C15.7236 1.88079 15.5784 1.85669 15.4999 1.85669C15.4215 1.85669 15.2763 1.88086 15.185 2.04238L1.8709 25.5863C1.77953 25.7478 1.83172 25.8883 1.8709 25.9576C1.91001 26.027 2.00313 26.1433 2.18586 26.1433H28.8142Z",
    fill: "#DB0716",
    fillOpacity: 0.662587
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7617,
    y: 8.8421,
    width: 1.47619,
    height: 10.3158,
    fill: "#DB0716",
    fillOpacity: 0.662587
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2379,
    cy: 22.1053,
    rx: 1.47619,
    ry: 1.47368,
    fill: "#DB0716",
    fillOpacity: 0.662587
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9ff7e58d71437f72374da9c318005421.svg";
export { ForwardRef as ReactComponent };